/// <reference types="user-agent-data-types" />

import { DeviceEffects, setOSVersion } from './device.state';

import { environment, RuntimeEnvironment } from '../../../environments/environment';
import { rootStore } from '../extension-store/extension.store';
import { setdeviceManagedState } from '../extension-store/global-flags.store';
import { DeviceManagedState, StateStatus } from '../extension-store/interfaces/extension-store.interfaces';
import UtilsService from '../utils/utils.service';

// Will return the Chrome version with the minor versions if available (e.g. 122.0.6261.95)
// If not available, it will return the major version (e.g. 122.0.0.0)
const getOSVersion = async (): Promise<string> => {
  if (environment.environment === RuntimeEnvironment.LOCAL && environment.localApiOverrides?.osVersion) {
    return environment.localApiOverrides?.osVersion;
  }

  let version = 'UNKNOWN';
  if (navigator.userAgentData) {
    const versionList: UADataValues = await navigator.userAgentData.getHighEntropyValues(['fullVersionList']);
    UtilsService.debugLog(`Detected Browser Agents`, versionList);
    version =
      versionList.fullVersionList?.find((osVersion) => osVersion.brand === 'Google Chrome')?.version ?? 'UNKNOWN';
    if (version !== 'UNKNOWN') {
      return version;
    }
  }
  const { userAgent } = navigator; // may not contain the minor version
  const verExp = /Chrome\/([0-9.]+)/;
  version = verExp.exec(userAgent)?.[1] ?? 'UNKNOWN';
  return version;
};

const DeviceService = {
  init: async (): Promise<void> => {
    UtilsService.debugLog('Device Service Init');

    // Fetch the device details from chrome api
    await rootStore.dispatch(DeviceEffects.fetchDeviceDetails());

    // Set the OS version
    const osVersion = await getOSVersion();
    rootStore.dispatch(setOSVersion(osVersion));
  },

  setManagedStatus: async () => {
    const currentState = rootStore.getState();
    if (
      currentState.deviceDetails.detailStatus === StateStatus.FAILED ||
      currentState.networkStatus.status === StateStatus.FAILED
    ) {
      rootStore.dispatch(setdeviceManagedState(DeviceManagedState.NOT_MANAGED));
    }
  },
};

export default DeviceService;
